export default {
    /**
     * Imports
     */
    completedImports(state) {
        return state.imports.filter(tmpImport => tmpImport.status == 'completed');
    },

    uncompletedImports(state) {
        return state.imports.filter(tmpImport => tmpImport.status == 'uncompleted');
    },

    failedImports(state) {
        return state.imports.filter(tmpImport => tmpImport.status == 'failed');
    },

    /**
     * Automations
     */
    runningAutomations(state) {
        return state.automations.filter(automation => automation.state == 'running');
    },

    pausedAutomations(state) {
        return state.automations.filter(automation => automation.state == 'paused');
    },
};
